
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import type { MortgageData } from "../../CalculatorTabs";
import { calculateMortgageData } from "@/utils/calculator/mortgageCalculator";
import { AutoCalculateOptions } from "../../utils/types";

interface HomebuyingHistorySelectProps {
  mortgageData: MortgageData;
  setMortgageData: React.Dispatch<React.SetStateAction<MortgageData>>;
  autoCalculate: AutoCalculateOptions;
}

const HomebuyingHistorySelect: React.FC<HomebuyingHistorySelectProps> = ({ 
  mortgageData, 
  setMortgageData,
  autoCalculate 
}) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">Homebuying History</Label>
      <Select 
        value={mortgageData.homebuyingHistory || ""}
        onValueChange={(value: "firstTime" | "purchasedLastThreeYears" | "other") => {
          setMortgageData(prev => {
            const updatedData = {
              ...prev,
              homebuyingHistory: value,
              isFirstTimeHomebuyer: value === "firstTime"
            };
            return calculateMortgageData(updatedData);
          });
        }}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select history" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="firstTime">First Time Homebuyer</SelectItem>
          <SelectItem value="purchasedLastThreeYears">Purchased within last 3 years</SelectItem>
          <SelectItem value="other">Other</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default HomebuyingHistorySelect;
